//REACT
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//YUP
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

//MUI
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";

import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { List, Typography } from "@mui/material";

//COMPONENTS
import { CustomScrollbar } from "../../customScrollbar/CustomScrollbar";

//TRANFER LIST
import ProductTransferList from "../../productTransferList/productTransferList";

const schema = yup.object().shape({
  prefix: yup.string("Code must be text").required("Code is required"),
  products: yup.array(),
});

const Form = ({ mode = "create", handleSave, currentProduct }) => {
  const isEdit = mode === "edit";
  const { id, dataCreation, ...promoPrefix } = currentProduct;

  const defaultValues = {
    ...{
      prefix: "",
      products: [],
    },
    ...promoPrefix,
  };

  const form = useForm({
    defaultValues,
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { register, handleSubmit, formState, reset } = form;
  const { errors, isValid, isDirty } = formState;

  useEffect(() => {
    reset(defaultValues);
  }, [currentProduct]);

  const onSubmit = (data) => {
    data.products = products;
    console.log("Data To BE", data);
    handleSave(data);
  };

  //Associated Products
  const getAssociatedProducts = () => {
    return (
      currentProduct?.products?.map((product) => ({
        id: product?.id,
        title: product?.title,
        productCode: product?.productCode,

        dataCreation: product?.dataCreation,
        price: product?.price,
        country: product?.country,
        description: product?.description,
        imageLink: product?.imageLink,
        promoCode: product?.promoCode,
        productType: product?.productType,
        points: product?.points,
        mission: product?.mission,
        promoPrefixes: product?.promoPrefixes,
      })) || []
    );
  };

  console.log(
    "assoc: ",
    currentProduct?.products?.map((product) => ({
      id: product.id,
      title: product.title,
    }))
  );

  //Selected data from Product Transfer List (Right)
  const [products, setProducts] = useState("");

  const handleProductListChange = (selectedProducts) => {
    const selectedProductIds = selectedProducts?.map((product) => ({
      id: product.id,
    }));
    const productsData =
      selectedProductIds?.length > 0 ? selectedProductIds : [];
    setProducts(productsData);
    console.log("Product To BE", { products: productsData });
  };

  return (
    <CustomScrollbar>
      <Box
        xs={12}
        id="promoPrefixForm"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="95%"
        maxHeight="35vw"
      >
        <Grid2 container spacing={3}>
          <Grid2 xs={12}>
            <Typography variant="h3" color="primary">
              Promo Prefix {isEdit ? "details" : "creation"}
            </Typography>
          </Grid2>
          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Prefix"
              color="primary"
              fullWidth
              required
              error={!!errors.prefix}
              helperText={errors.prefix?.message}
              {...register("prefix")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <ProductTransferList
              onExportRightData={handleProductListChange}
              associatedProducts={getAssociatedProducts()}
              currentProduct={currentProduct}
            />
          </Grid2>

          <Grid2 xs={6} sx={{ display: "none" }}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Product ID"
              color="primary"
              fullWidth
              value={products}
              {...register("products.id")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <Tooltip arrow title={(false && "a") || ""}>
              <LoadingButton
                type="submit"
                loading={false}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                sx={{
                  boxShadow: "none",
                  padding: "5px 12px 4px 12px",
                }}
                color="primary"
                onClick={() => {}}
                disabled={isDirty && !isValid}
              >
                Save
              </LoadingButton>
            </Tooltip>
          </Grid2>
        </Grid2>
      </Box>
    </CustomScrollbar>
  );
};

export default Form;
